import { useEffect, useMemo, useRef, useState } from 'react'
import { GetServerSideProps } from 'next'
import { GlobalRequest } from '~/components/global-requset'
import { GET_SPECIAL_DETAIL, GET_ALL_ITEM_LIST } from '~/graphqls/gqls/mall'
import {
  getSpecialDeatil,
  getSpecialDeatilVariables,
  getSpecialDeatil_marketingModule_special,
  MallProductStatus,
  getAllItemList,
  getAllItemListVariables,
  getAllItemList_itemModule_itemList_edges_node,
} from '~/graphqls/types'
import { Container } from '~/components/ui/Container'
import { Layout } from '~/layouts/default'
import { SEOHead } from '~/components/business/SEOHead'
import { getGraphData } from '~/utils'
import { MallItem } from '~/components/business/MallItem'
import { Col, Row } from 'antd'

interface styleDataType {
  firstimg?: string
  list?: {
    id?: number
    img?: string
    [key: string]: any
  }[]
  area?: {
    starX?: number
    starY?: number
    areaWidth?: number
    areaHeight?: number
    url?: string
  }[]
  shareInfo?: {
    share_image?: string
    share_desc?: string
  }
}
export default function Item({
  itemData,
  itemList,
  styleData,
}: {
  itemData: getSpecialDeatil_marketingModule_special
  itemList: getAllItemList_itemModule_itemList_edges_node[]
  styleData: styleDataType
}) {
  return (
    <Layout>
      <SEOHead title={itemData.name} desc={itemData.desc} />
      <Container>
        <div className="mb-[72px] rounded-2xl overflow-hidden">
          <img className="w-full block" src={styleData?.firstimg} alt="" />
        </div>
        {itemList?.length ? (
          <Row gutter={32}>
            {itemList?.map(item => (
              <Col span={8} key={item.id}>
                <MallItem data={item} />
              </Col>
            ))}
          </Row>
        ) : (
          ''
        )}
      </Container>
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  const { initialState, client } = await GlobalRequest(context)
  try {
    const slug = context.params?.slug as string
    const productRes = await client.query<
      getSpecialDeatil,
      getSpecialDeatilVariables
    >({
      query: GET_SPECIAL_DETAIL,
      variables: {
        slug: slug,
      },
      fetchPolicy: 'no-cache',
    })
    if (
      productRes?.data?.marketingModule?.special?.status !==
      MallProductStatus.ON
    ) {
      return {
        notFound: true,
      }
    }
    const itemData = productRes?.data?.marketingModule?.special || {}
    const styleData =
      (itemData.styleDate && JSON.parse(itemData.styleDate)) || {}
    let ids: number[] = []
    let itemList: getAllItemList_itemModule_itemList_edges_node[] = []
    if (itemData.style === 2) {
      styleData.list.forEach((item: any) => {
        if (item && item.item_id) {
          ids.push(Number(item.item_id))
        }
      })
      const itemRes = await client.query<
        getAllItemList,
        getAllItemListVariables
      >({
        query: GET_ALL_ITEM_LIST,
        variables: {
          offset: 0,
          first: ids.length,
          idList: ids,
        },
        fetchPolicy: 'no-cache',
      })
      itemList = getGraphData(
        itemRes?.data?.itemModule?.itemList?.edges || []
      ).sort((a, b) => {
        return ids.indexOf(a.id) - ids.indexOf(b.id)
      })
    } else {
      // TODO 图片模式暂时404，pc展示效果不好
      return {
        notFound: true,
      }
    }
    return {
      props: {
        initialState,
        itemData: itemData,
        itemList: itemList,
        styleData: styleData,
      },
    }
  } catch (error) {
    return {
      notFound: true,
    }
  }
}
